var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRfid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    stroke: "#767676",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Bitstream Vera Sans"
    },
    d: "M 11 2 C 6.0545455 2 2 6.0545455 2 11 C 2 15.945455 6.0545455 20 11 20 L 11 18 C 7.1454545 18 4 14.854545 4 11 C 4 7.1454545 7.1454545 4 11 4 C 14.854545 4 18 7.1454545 18 11 L 20 11 C 20 6.0545455 15.945455 2 11 2 z M 11 6 C 8.2545455 6 6 8.2545455 6 11 C 6 13.745455 8.2545455 16 11 16 L 11 14 C 9.3454545 14 8 12.654545 8 11 C 8 9.3454545 9.3454545 8 11 8 C 12.654545 8 14 9.3454545 14 11 L 16 11 C 16 8.2545455 13.745455 6 11 6 z M 11 10 C 10.447715 10 10 10.447715 10 11 C 10 11.552285 10.447715 12 11 12 C 11.552285 12 12 11.552285 12 11 C 12 10.447715 11.552285 10 11 10 z M 15.5 13 L 13 15.5 L 13 21 C 13 21.6 13.4 22 14 22 L 21 22 C 21.6 22 22 21.6 22 21 L 22 14 C 22 13.4 21.6 13 21 13 L 15.5 13 z M 16 16 L 19 16 L 19 19 L 16 19 L 16 16 z",
    overflow: "visible",
    enableBackground: "accumulate",
    fontFamily: "Bitstream Vera Sans"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfid);
export default __webpack_public_path__ + "static/media/rfid.1923a972.svg";
export { ForwardRef as ReactComponent };